/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { UserRoles } from '../constants/user';
import { UserMin, UserPermissions } from '../constants/users';

const validRoles: string[] = Object.values(UserRoles);
export const getUserRoles = ({ permissions }: { permissions?: UserPermissions[] }) => {
  if (!permissions) {
    return [];
  }

  const roles = permissions.map(p => p.permissions).flat().filter(r => validRoles.includes(r));
  return Array.from(new Set(roles));
};


export const getFullName = (user: Pick<UserMin, 'firstName' | 'surname'>, fallback = '-') => {
  return `${user.firstName ?? ''} ${user.surname ?? ''}`.trim() || fallback;
}
